'use client'

import BugsnagPerformance from '@bugsnag/browser-performance'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import React, { ReactNode } from 'react'
import { useRecoilValue } from 'recoil'

import { loginUserState } from '@/components/Context/JwtTokenProvider'

export default function ErrorBoundaryProvider({ children }: { children: ReactNode }) {
  const apiKey = process.env.NEXT_PUBLIC_BUGSNAG_API_KEY || null
  const appVersion = process.env.NEXT_PUBLIC_BUILD_ID || null
  const loginUser = useRecoilValue(loginUserState)
  if (apiKey == null || appVersion == null) {
    return <>{children}</>
  }

  Bugsnag.start({
    apiKey,
    appVersion,
    plugins: [new BugsnagPluginReact(React)],
    appType: 'nextjs',
    onError: (event) => {
      if (loginUser != null) {
        event.setUser(loginUser.userId, loginUser.userId, loginUser.baseUser.baseUserId)
      }
    },
  })

  BugsnagPerformance.start({
    apiKey,
    appVersion,
  })

  // @ts-ignore
  const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React)

  return <ErrorBoundary>{children}</ErrorBoundary>
}
